import { render, staticRenderFns } from "./WhatsappConversationDetails.vue?vue&type=template&id=6c68c88a&"
import script from "./WhatsappConversationDetails.vue?vue&type=script&lang=ts&"
export * from "./WhatsappConversationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports